import { render, staticRenderFns } from "./mySubscribe.vue?vue&type=template&id=4fd1c0ed&scoped=true"
import script from "./mySubscribe.vue?vue&type=script&lang=js"
export * from "./mySubscribe.vue?vue&type=script&lang=js"
import style0 from "./mySubscribe.vue?vue&type=style&index=0&id=4fd1c0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1c0ed",
  null
  
)

export default component.exports